import { render } from "./LinkDetail.vue?vue&type=template&id=1de8d8de"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__